import 'babel-polyfill';
import 'intersection-observer';
import Vue from 'vue';
import App from './App.vue';
import vueCookies from 'vue-cookies';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import axios from 'axios';

const apiBaseUrl = process.env.VUE_APP_API_SERVER;

Vue.config.productionTip = false;
Vue.use(vueCookies);

axios.interceptors.request.use(
  request => {
    request.url = apiBaseUrl + request.url;
    return request;
  },
  error => {
    return new Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      store.commit('snackbar/showSnackbar', {
        text: 'Invalid or expired credentials. Please login again',
        color: 'error'
      });
      return Promise.reject(error);
    }
  }
);

new Vue({
  router,
  store,
  vuetify,
  created() {
    store.commit('user/checkAuth');
    if (store.state.user.isAuthorized) {
      store.dispatch('user/checkAuthAgainstAPI');
    } else {
      store.dispatch('user/logout');
    }
  },
  render: h => h(App)
}).$mount('#app');
